var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('a-button',{attrs:{"type":"primary"},on:{"click":_vm.scanIt}},[_vm._v("扫一扫")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }